module.exports = __webpack_public_path__ + "fonts/Kostic-Roc-Grotesk-Extra-Bold.18d95d1.otf";